import React, { FC } from 'react';

import clsx from 'clsx';

import { FieldValidationMessage } from '../fieldValidationMessage/FieldValidationMessage';
import { FormControlLabel } from '../label';
import { Select, SelectProps } from '../select/Select';

export type SelectFieldProps = {
	id: string;
	title?: string;
	errorMessage?: string;
	classes?: {
		input?: string;
		label?: string;
		validation?: string;
	};
} & SelectProps;

export const SelectField: FC<SelectFieldProps> = ({
	id,
	title,
	acceptanceTestTargetId = id,
	invalid,
	classes,
	errorMessage,
	required,
	...rest
}) => (
	<FormControlLabel
		acceptanceTestTargetId={acceptanceTestTargetId ? `${acceptanceTestTargetId}-label` : undefined}
		className={classes?.label}
		formControlId={id}
		required={required}
		title={title}
	>
		<Select {...rest} acceptanceTestTargetId={acceptanceTestTargetId} id={id} invalid={invalid} />
		<FieldValidationMessage
			acceptanceTestTargetId={acceptanceTestTargetId ? `${acceptanceTestTargetId}-message` : undefined}
			className={clsx(classes?.validation, invalid && 'field-error')}
			errorMessage={errorMessage}
			id={`${id}-message`}
		/>
	</FormControlLabel>
);
